import { Decrypt } from '@/utils/crypto'
import { ejs } from '@epoint-mrc/ejsv4'
import { reqSstCodeLogin } from '../service/form'

// 检测平台
// 平台编号 1是微信 2是住枫桥 3企业微信 4惠姑苏
/* eslint-disable */
export function checkPlatform(platform) {
  // console.log(platform, '接口返回支持的平台')
  platform = platform.map((item) => item.toString())
  console.log('platform', platform)

  // console.log(platform, '接口返回支持的平台2')
  //获取浏览器UA
  var ua = navigator.userAgent
  // 平台映射关系
  const platformObj = {
    '1': 'MicroMessenger',
    '2': 'CityId/215129',
    '3': 'wxwork',
    '4': 'GusuClient',
    '5': 'szd_SZGov',
    '6': 'CityId/320583',
    '7': 'SuGaoXinClient',
    '8': 'WoDeXuZhouClient',
    '9': 'szxcWxMiniClient',
    '10': 'EpointEJS'
  }

  const platformDesc = {
    MicroMessenger: '微信',
    'CityId/215129': '住枫桥',
    wxwork: '企业微信',
    GusuClient: '惠姑苏',
    szd_SZGov: '苏周到',
    'CityId/320583': '第一昆山',
    SuGaoXinClient: '苏高新',
    WoDeXuZhouClient: '我的徐州',
    szxcWxMiniClient: '苏州相城总入口小程序',
    EpointEJS: '苏商通'
  }
  var supportTip = [] //支持的平台文字
  var supportId = [] //支持的平台编号
  var currentUa = '' // 1 2 3 4 5 6
  for (var i in platformObj) {
    // debugger
    if (ua.indexOf(platformObj[i]) != -1) {
      currentUa = i
    }
    if (platform.indexOf(i) != -1) {
      supportTip.push(platformDesc[platformObj[i]])
      supportId.push(i)
    }
  }

  return new Promise((resolve, reject) => {
    if (platform.indexOf(currentUa) != -1) {
      // todo login
      resolve()
    } else {
      // 提示不支持 格式: 微信/住枫桥
      // console.log(supportTip, 'supportTip')
      supportTip = supportTip.map((item) => item).join('/')
      reject({ supportTip, supportId })
    }
  })
}
// 封装拉起登录
export async function callLogin(api_host, form_id) {
  return new Promise((resolve, reject) => {
    window.login(api_host, form_id, (loginInfo) => {
      console.log(loginInfo, 'callLogin loginInfo.....')
      if (loginInfo) {
        let result = {}
        const afterLogin = () => {
          try {
            // 解密返回用户信息
            let userInfo = Decrypt(loginInfo.userInfo)
            result = JSON.parse(userInfo.split('}')[0] + '}')
            console.log(result, 'callLogin result...')
            console.log(loginInfo, '----------callLogin loginInfo----------')
          } catch (error) {
            console.log(error)
          }
          // 如果需要实名的同时未实名
          if (loginInfo.needShimingBoard == 1 && !result.idcard) {
            // 拉起实名认证
            // 判断环境
            if (ua.indexOf('GusuClient') != -1) {
              // 拉起惠姑苏实名
              hgsrealname(api_host, form_id)
            } else if (ua.indexOf('szd_SZGov') != -1) {
              // 拉起苏周到实名
              szdrealname(api_host, form_id)
            } else if (ua.indexOf('CityId/320583') != -1) {
              // 拉起第一昆山实名
              kunshanrealname(api_host, form_id)
            } else if (ua.indexOf('SuGaoXinClient') != -1) {
              // 拉起苏高新实名
              sgxrealname(api_host, form_id)
            } else if (ua.indexOf('WoDeXuZhouClient') != -1) {
              // 拉起我的徐州实名
              wdxzrealname(api_host, form_id)
            } else if (ua.indexOf('EpointEJS') != -1) {
              // 拉起苏商通实名
              sstrealname(api_host, form_id)
            }
          } else {
            resolve(loginInfo)
          }
        }
        if (loginInfo.isSst) {
          // 苏商通登陆单独处理
          const apiName = ejs.os.android ? 'com.epoint.workarea.api.CustomEjsApi' : 'SZEJSApi'
          ejs.config({
            jsApiList: [{
              ticketApiName: apiName
            }]
          })
          ejs.ready(function () {
            getSSTToken(api_host, form_id, function (res) {
              console.log(res, '苏商通res...')
              loginInfo = res
              // loginInfo.needShimingBoard = 1
              afterLogin()
            })
          })
        } else {
          afterLogin()
        }
      } else {
        reject()
      }
    })
  })
}

// 惠姑苏实名方法
function hgsrealname(api_host, form_id) {
  GSApi.user.authentication(function (val) {
    console.log(val, '实名回调')
    if (val == 1) {
      callLogin(api_host, form_id)
    } else {
      GSApi.back()
      GSApi.back()
    }
  })
}

//苏周到实名方法
function szdrealname(api_host, form_id) {
  window.realnamesuccess = function () {
    window.getUserInfo(async function (data) {
      let idCard = JSON.parse(data).idCard
      if (idCard && idCard.length > 0) {
        location.replace(location.href.split('?')[0])
        callLogin(api_host, form_id)
      } else {
        window.closeWindow(api_host, form_id)
      }
    })
  }
  window.doRealNameAuth('realnamesuccess')
}

// 第一昆山实名方法
function kunshanrealname(api_host, form_id) {
  // 是否实名
  const identity = window.PalauAPI.user.userInfo().auth.identity
  if (parseInt(identity) === 1) {
    // 已经实名
    callLogin(api_host, form_id)
  } else {
    // 未实名
    window.PalauAPI.user.authentication((code) => {
      console.log('code', code)
      if (code == 0) {
        // 实名认证失败
        window.PalauAPI.back()
      } else {
        callLogin(api_host, form_id)
      }
    })
  }
}
// 苏高新实名方法
function sgxrealname(api_host, form_id) {
  window.SFApi.user.authentication((res) => {
    console.log(res, '----苏高新实名回调----')
    if (res && res == 1) {
      callLogin(api_host, form_id)
    } else {
      window.SFApi.back()
    }
  })
}
// 我的徐州实名方法
function wdxzrealname(api_host, form_id) {
  window.SFApi.user.authentication((res) => {
    console.log(res, '----我的徐州实名回调----')
    if (res && res == 1) {
      callLogin(api_host, form_id)
    } else {
      window.SFApi.back()
    }
  })
}

// 苏商通登陆
function getSSTToken(api_host, form_id, callback) {
  ejs.callApi({
    name: 'loginAndGetTicket',
    mudule: 'ticketApiName',
    data: {
      client_id: '7938a273-fbcb-43e6-b574-08c1b9f1d4b6'
      // client_id: env.VITE_ENV === 'production' ? '1c8ca3aee4ec4780ba25ee365df06c39' : '1c8ca3aee4ec4780ba25ee365df06c39'
    },
    success: function(result) {
      if (result.code == 1) {
        const params = {
          code: result.ticket,
          form_id: form_id
        }
        reqSstCodeLogin(params)
          .then((res) => {
            callback(res)
          })
          .catch((err) => {
            console.log(err, '授权登录异常')
          })
      } else {
        ejs.page.close('')
        console.log(result, '授权登录异常')
      }
    },
    error: function (err) {
      console.log('222222222222222222')
      console.log(err, '授权登录异常')
    }
  })
}

// 苏商通实名方法
function sstrealname(api_host, form_id) {
  const rzUrl = 'https://sst.suzhou.gov.cn/sst-web-ystmh/ejs.m8.suzhouLegal/dist/index.html#/personinfo/personinfo_save'
  // 前往实名认证
  ejs.page.open(rzUrl)
}

